var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { utilities } from "./utilities/utilities";
export var cookieBot = {
    bannerScript: "\n        <script id=\"Cookiebot\" src=\"https://consent.cookiebot.com/uc.js\" data-cbid=\"c26ed92c-7213-4fc5-82a5-e85c82486cf6\" data-blockingmode=\"auto\" type=\"text/javascript\" async></script>\n    ",
    declarationScript: "\n        <script id=\"CookieDeclaration\" src=\"https://consent.cookiebot.com/c26ed92c-7213-4fc5-82a5-e85c82486cf6/cd.js\" type=\"text/javascript\" async></script>\n    ",
    //Weird quirk with <script> tags
    // The problem is that browsers don’t execute <script> elements created via innerHTML or template literals — even if they become part of the DOM. When you insert a <script> this way, it appears in the DOM visually, but it won’t actually load or execute.
    createLiveScript: function (script) {
        var inertScript = typeof script === 'string'
            ? utilities.html(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", ""], ["", ""])), script) : script;
        var liveScript = document.createElement('script');
        __spreadArray([], inertScript.attributes, true).forEach(function (attr) {
            return liveScript.setAttribute(attr.name, attr.value);
        });
        if (inertScript.textContent) {
            liveScript.text = inertScript.textContent;
        }
        liveScript.async = true;
        return liveScript;
    },
    appendBannerScript: function () {
        if (document.querySelector('#CookieBot'))
            return;
        document.head.insertBefore(this.createLiveScript(this.bannerScript), document.head.firstChild);
    },
    renderDeclaration: function (container) {
        if (!document.querySelector('#CookieDeclaration')) {
            var target = null;
            if (container) {
                target = typeof container === 'string'
                    ? document.querySelector(container)
                    : container;
            }
            (target || document.body).appendChild(this.createLiveScript(this.declarationScript));
        }
        var result = utilities.html(templateObject_2 || (templateObject_2 = __makeTemplateObject(["<div id=\"cookie-declaration-container\"></div>"], ["<div id=\"cookie-declaration-container\"></div>"])));
        return result;
    }
};
var templateObject_1, templateObject_2;
